import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import useAuthStore from "../../stores/useAuthStore";

const SignInCallback = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const checkSession = useAuthStore((state) => state.checkSession);
    const session = useAuthStore((state) => state.session);

    const [checked, setChecked] = useState(false);

    useEffect(() => {
        checkSession().then(() => setChecked(true));
    }, [checkSession]);

    useEffect(() => {
        if (!checked) {
            return;
        }
        if (session) {
            navigate("/");
        } else {
            navigate("/auth/sign-in");
        }
    }, [checked, session, navigate]);

    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "50vh" }}>
            <p>{t("auth.loading")}</p>
        </div>
    );
};

export default SignInCallback;
